import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';

import { SvgLogo } from '../../SvgLogo';

const useStyles = makeStyles((theme) => ({
  overlay: {
    padding: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      padding: rem(16),
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    position: 'fixed',
    top: '0px',
    right: '0',
    left: '0',
    bottom: '0',
    backgroundColor: theme.palette.background.default,
    zIndex: theme.zIndex.drawer + 1,
  },
  logo: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: rem(64),
    marginBottom: rem(80),
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      flexBasis: '50%',
    },
  },
  spinner: {
    marginTop: rem(20),
  },
}));

// A full-screen "please wait" screen: the logo, an optional message, and a spinner.
const LoadingOverlay = ({ children, visible }) => {
  const classes = useStyles();

  if (!visible) {
    return null;
  }

  return (
    <Box className={classes.overlay}>
      <Box className={classes.logo}>
        <SvgLogo />
      </Box>
      {children}
      <CircularProgress className={classes.spinner} />
    </Box>
  );
};

LoadingOverlay.propTypes = {
  children: PropTypes.node,
  visible: PropTypes.bool,
};

export default LoadingOverlay;
